import enUS from './en-US.json'

import colorEnUS from './colors/en-US.json'

import ptBR from './pt-BR.json'

import colorPtBR from './colors/pt-BR.json'

export default {
  'en-US': {
    ...enUS,
    ...colorEnUS
  },
  'pt-BR': {
    ...ptBR,
    ...colorPtBR
  }
}
